import { css } from 'linaria';

export const withoutPropagationWrapperStyles = css`
  display: inline;
`;
